import React from 'react';
import { motion } from 'framer-motion';
const reviews = [{
  id: 1,
  text: 'Nunca pensé que iba a poder organizarme con tantas materias a la vez. Los planificadores me cambiaron la cursada.',
  author: 'Valentina R.',
  details: 'UBA, 3er año'
}, {
  id: 2,
  text: 'Los resúmenes de corrientes son clarísimos. Estudié para el parcial de Teorías con el tomo de Psicoanálisis y saqué un 9.',
  author: 'Lucía M.',
  details: 'UNLP, 2do año'
}, {
  id: 3,
  text: 'Lo que más me sorprendió fue el tomo clínico. Nunca había visto una guía así para armar la primera entrevista. Una joya.',
  author: 'Tomás G.',
  details: 'UNC, 4to año'
}];
export function Reviews() {
  return <section className="bg-brand-darker py-12 px-4 sm:px-6 lg:px-8" data-id="element-211">
      <div className="max-w-2xl mx-auto" data-id="element-212">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl font-bold text-center text-white mb-8" data-id="element-213">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <div className="space-y-4" data-id="element-214">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-dark border border-brand-violet/30 rounded-xl p-5 shadow-sm" data-id="element-215">
              <div className="text-brand-gold mb-2 text-sm tracking-widest" data-id="element-216">
                🌟🌟🌟🌟🌟
              </div>
              <p className="text-gray-200 italic mb-4 text-[15px]" data-id="element-217">
                "{review.text}"
              </p>
              <div className="text-sm font-medium" data-id="element-218">
                <span className="text-white" data-id="element-219">{review.author}</span>
                <span className="text-gray-400" data-id="element-220"> · {review.details}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}